'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _paths = require('./paths');

var _middleware = require('../../middleware');

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

exports.default = function () {
  return function (dispatch, getState) {
    var dances = (0, _paths.getDances)(getState());

    // prefer the cached version
    if (dances) return;

    dispatch(_defineProperty({}, _middleware.CALL_API, {
      config: {
        url: (0, _paths.dancesPrefix)()
      },
      types: ['GET_DANCES_START', 'GET_DANCES', 'GET_DANCES_ERROR']
    }));
  };
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/setMusic/getDances.js
// module id = 678
// module chunks = 0